import { getUserFacingErrorMessage } from "@coval/ui"

const METRIC_FIELD_LABELS: Record<string, string> = {
  category: "Category",
  description: "Description",
  metric_display_name: "Metric name",
  metric_manager: "Metric type",
  metric_metadata: "Metric configuration",
  metric_name: "Metric name",
  output_type: "Output type",
  tags: "Tags",
}

export function getMetricSaveErrorMessage(error: unknown) {
  return getUserFacingErrorMessage(error, {
    detailMessage: true,
    fallback: error instanceof Error ? error.message : "Unknown error",
    fieldLabels: METRIC_FIELD_LABELS,
  })
}
